import React, { HTMLAttributes } from 'react';
import AccountCard from './AccountCard';
import cn from '@/utils/cn';
import { TWalletData } from '../types/WalletData';

interface AccountCardGroupProps extends HTMLAttributes<HTMLDivElement> {
  options: TWalletData[];
  onViewBankAccount?: () => void;
}

const AccountCardGroup: React.FC<AccountCardGroupProps> = ({
  className,
  options,
  onViewBankAccount,
  ...props
}) => {
  return (
    <div
      className={cn('flex flex-row gap-x-2 pb-4 overflow-x-auto horizontal-scroll', className)}
      {...props}>
      {options.map((option, index) => (
        <AccountCard key={index} data={option} onViewBankAccount={onViewBankAccount} />
      ))}
    </div>
  );
};

export default AccountCardGroup;
